import { render, staticRenderFns } from "./IframeVerificaIscritti.vue?vue&type=template&id=74d31a1c"
import script from "./IframeVerificaIscritti.vue?vue&type=script&lang=js"
export * from "./IframeVerificaIscritti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports